import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Typography, Grid, Button } from '@mui/material';
import { Link } from 'gatsby';
import pop from '../../themes/ThemeProviders/colors/pop';

const EngagementImg = styled('img')(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  display: 'block',
  width: '900px',
}));

const ctaButton = () => ({
  minWidth: 250,
  marginBottom: '1rem',
  marginRight: '0.5rem',
});

const CTAPrimaryButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText(pop[400]),
  backgroundColor: pop[400],
  '&:hover': {
    backgroundColor: pop[600],
  },
}));

function DigitaliseMaterial({
  title, buttonText, image,
}) {
  return (
        <div>
            <Typography
                sx={(theme) => ({
                  [theme.breakpoints.up('md')]: {
                    fontSize: '44px',
                    lineHeight: '56px',
                    marginTop: '2rem',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    maxWidth: '600px',
                  },
                  fontWeight: 'bold',
                  fontSize: '26px',
                  lineHeight: '32px',
                  marginTop: '1rem',
                })}
                variant="h2"
                component="h2"
                textAlign={'center'}
            >
                {title}
            </Typography>
            <Grid
                container
                justifyContent="center"
                alignItems="center"
                sx={(theme) => ({
                  [theme.breakpoints.up('md')]: {
                    marginTop: 10,
                  },
                  marginTop: 1,
                })}
            >
                <EngagementImg
                    src={image}
                />
            </Grid>
            <Grid
                container
                justifyContent="center"
                alignItems="center"
                sx={(theme) => ({
                  [theme.breakpoints.up('md')]: {
                    marginTop: 5,
                  },
                  marginTop: 2,
                })}
            >
                <CTAPrimaryButton
                    variant="contained"
                    component={Link}
                    to="#publisher-contact-form"
                    sx={ctaButton}
                >
                    {buttonText}
                </CTAPrimaryButton>
            </Grid>
        </div>
  );
}

DigitaliseMaterial.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.shape({ type: PropTypes.oneOf(['img', 'svg']) }),
  buttonText: PropTypes.string.isRequired,
};

export default DigitaliseMaterial;
